import { Controller } from "@hotwired/stimulus"

// Opens the partner OAuth flow in a popup (from the user's click, so it isn't blocked) and,
// once the merchant closes the popup, redirects this page back to the courier accounts list.
// EasyPost controls the post-OAuth redirect and there's no app-side callback, so a closed
// popup is the completion signal we can observe.
export default class extends Controller {
  static values = { returnUrl: String }

  open(event) {
    event.preventDefault()

    const url = this.element.href
    const width = 600
    const height = 720
    const left = window.screenX + (window.outerWidth - width) / 2
    const top = window.screenY + (window.outerHeight - height) / 2

    const popup = window.open(
      url,
      "courier_oauth",
      `popup,width=${width},height=${height},left=${left},top=${top}`
    )

    // Popup blocked (rare for a direct click) — fall back to a full-page redirect.
    if (!popup) {
      window.location.href = url
      return
    }

    popup.focus()

    this.pollId = setInterval(() => {
      if (popup.closed) {
        this.stopPolling()
        window.location.href = this.returnUrlValue
      }
    }, 500)
  }

  disconnect() {
    this.stopPolling()
  }

  stopPolling() {
    if (this.pollId) {
      clearInterval(this.pollId)
      this.pollId = null
    }
  }
}
